import { RESOURCE } from '@src/constants';
import api from './api';

const getSampleScript = async ({ language }) => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.SAMPLE_SCRIPTS,
    params: {
      language,
    },
  });
  return response;
};

export { getSampleScript };
